import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'
import { showLoading, hideLoading } from '../assets/js/loading.js';
// import { aes } from "./crypto.js";
// import { getToken, TokenKey } from '@/utils/auth'
// const Base64 = require('js-base64').Base64
// create an axios instance
const service = axios.create({
    timeout: 200000,
    headers: {
        'Content-Type': 'application/json; charset=utf-8;',
    },
    withCredentials: true
})

service.interceptors.request.use(config => {
    // showLoading();
    // if (config.aes) {
    //     config.params = {encrypt: aes.en(JSON.stringify(config.params))};        
    // }
    config.data = JSON.stringify(config.params);
    return config
}, error => {
    Promise.reject(error)
})
service.interceptors.response.use(
    response => {
        // hideLoading();
        const res = response.data;
        if (res.code == 403) {
            Message.closeAll()
            Message({
                message: 'Session expired',
                type: 'error',
                duration: 5 * 1000
            });
            router.push('/')
            return Promise.reject('error');
        }
        return response
    },
    error => {
        Message({
            message: error + '',
            type: 'error',
            duration: 5 * 1000
        })
        hideLoading();
        return Promise.reject(error)
    }
)
export default service